import { CmsApiRichTextBlockData } from 'modules/cms/api/types/CmsApiRichText';
import { CmsBlockWidth } from 'modules/cms/api/types/CmsBlockWidth';
import { CmsBlockMapping } from 'modules/cms/blocks/CmsBlockMapping';

import { CmsAmpRichTextBlock } from './CmsAmpRichTextBlock';
import { CmsRichTextBlock } from './CmsRichTextBlock';

export const CmsRichTextBlockMapping: CmsBlockMapping<CmsApiRichTextBlockData> =
  {
    invariant: [
      {
        prop: 'html',
        msg: 'Html data required for rich text',
      },
    ],
    width: CmsBlockWidth.INSET,
    Component: CmsRichTextBlock,
    AmpComponent: CmsAmpRichTextBlock,
  };
